"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentsCondensed = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
function CommentsCondensed(comments, maxComments, anonymityLevel, containerProps) {
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, containerProps);
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `Comments (${comments.length})`,
        weight: adaptivecards_1.TextWeight.Bolder,
        color: adaptivecards_1.TextColor.Default,
    }));
    comments
        .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
        .slice(0, maxComments)
        .forEach(comment => {
        let text = comment.value.substring(0, 250);
        if (comment.value.length > text.length) {
            text += "...";
        }
        if (anonymityLevel === "none") {
            text = `**${comment.user.name}** ${text}`;
        }
        container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: `💬 ${text}`,
            wrap: true,
        }));
    });
    if (comments.length > maxComments) {
        container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: `${comments.length - maxComments} more comments...`,
            color: adaptivecards_1.TextColor.Accent,
            separator: true,
        }));
    }
    return container;
}
exports.CommentsCondensed = CommentsCondensed;
//# sourceMappingURL=CommentsCondensed.js.map